/**
 * Dependencies
 */
import {polaris} from "./config";
import {submitForm} from "./core";


/**
 * Errors App APIs
 */
export const errorsAPIs = () => {

};
